import adAuth from "./adV2";

class ADAuth {
  isLoggedIn() {
    if (adAuth.getAccessToken()) {
      return true;
    }
    return false;
  }
  getToken() {
    return adAuth.getAccessToken();
  }
  currentUser() {
    return adAuth.getUser();
  }
  getSystemCredentials() {
    return adAuth.getCredentials();
  }
}

export default ADAuth;
